export default "__VITE_ASSET__Vc7MkFlq__"